export function setupForLoopAnimation(container, selector) {
	const items = container.querySelectorAll(selector);
	const firstItemClone = items[0].cloneNode(true);
	const lastItemClone = items[items.length - 1].cloneNode(true);
	if (firstItemClone?.id) {
		firstItemClone.id = `${firstItemClone.id}-clone`;
	}
	if (lastItemClone?.id) {
		lastItemClone.id = `${lastItemClone.id}-clone`;
	}
	container.append(firstItemClone);
	container.prepend(lastItemClone);
}

export function ontransitionendNew(containers, heights, totalItems) {
	this.transitionDone = true;
	if (this.currentItemId === 1) {
		this.currentItemId = totalItems - 1;
		containers.forEach((item, index) => {
			item.style.transition = 'none';
			item.style.transform = `translateY(-${(totalItems - 2) * heights[index]}px)`;
		});
	}
	if (this.currentItemId === totalItems) {
		this.currentItemId = 2;
		containers.forEach((item, index) => {
			item.style.transition = 'none';
			item.style.transform = `translateY(-${heights[index]}px)`;
		});
	}
}
